export default "__VITE_ASSET__CsCIF$YK__"